import { getPath } from '@/router/common'
const baseUrl = {
  title: '到货库存',
  path: 'ArrivalInventory'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'ArrivalInventory_index',
    component: () => import(/* webpackChunkName: "ArrivalInventory_index" */ '@/views/arrivalInventory/index/index.vue'),
    meta: {
      title: '到货库存'
    }
  },
  {
    path: getPath('EditOkprocess', baseUrl),
    name: 'ArrivalInventory_EditOkprocess',
    component: () => import(/* webpackChunkName: "ArrivalInventory_EditOkprocess" */ '@/views/arrivalInventory/editOkprocess/index.vue'),
    meta: {
      title: '修改交接方式'
    }
  }
]
